module.exports = __webpack_public_path__ + "static/media/tree.ab77c110.png";